export default __webpack_public_path__ + "static/media/image3.65f351e9.svg";